import React from 'react';
import useTerrainSettings from '../../hooks/useTerrainSettings';

/**
 * Inversion panel: "Use project DEM for surface" (docs/DEM_TERRAIN.md, section 4). When
 * on, SectionView hangs models without topography from the project DEM and draws the DEM
 * line beside a model's own surface. Disabled (with the reason) without a project DEM.
 */
export default function DemSurfaceToggle({ C }) {
  const t = useTerrainSettings();
  const has = !!t.demDatasetId;
  return (
    <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 10 }} data-testid="dem-surface-toggle">
      <div style={{ fontSize: 10, fontWeight: 600, color: C.text2, textTransform: 'uppercase', marginBottom: 6 }}>Terrain</div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 10, color: has ? C.text2 : C.text3, cursor: has ? 'pointer' : 'default' }}>
        <input type="checkbox" disabled={!has} checked={has && t.useDemSurface}
          onChange={(e) => t.set({ useDemSurface: e.target.checked })} style={{ accentColor: C.cyan }} />
        Use project DEM for surface
      </label>
      <div style={{ fontSize: 9, color: C.text3, marginTop: 2 }}>
        {has
          ? `${t.dem?.name || 'Project DEM'}${t.dem?.vertical_datum ? ` · ${t.dem.vertical_datum}` : ''} — sections show elevation = DEM − depth`
          : 'No project DEM: open a DEM dataset and choose “Use as project DEM”.'}
      </div>
    </div>
  );
}
